import { VariableType } from './Field';
export var SelectionMode;
(function (SelectionMode) {
    SelectionMode["ALL"] = "ALL";
    SelectionMode["INCLUDE"] = "INCLUDE";
    SelectionMode["EXCLUDE"] = "EXCLUDE";
    SelectionMode["EXCLUDE_ALL"] = "EXCLUDE_ALL";
})(SelectionMode || (SelectionMode = {}));
// relative condition?
export var ConditionType;
(function (ConditionType) {
    ConditionType["RANGE"] = "RANGE";
    ConditionType["RELATIVE_DATE"] = "RELATIVE_DATE";
    ConditionType["SELECTION"] = "SELECTION";
})(ConditionType || (ConditionType = {}));
export var FilterType;
(function (FilterType) {
    FilterType["Discrete"] = "DISCRETE";
    FilterType["DiscreteBoolean"] = "DISCRETE_BOOLEAN";
    FilterType["Continuous"] = "CONTINUOUS";
    FilterType["ContinuousDate"] = "CONTINUOUS_DATE";
    FilterType["RelativeDate"] = "RELATIVE_DATE";
    FilterType["TopByField"] = "TOP_BY_FIELD";
})(FilterType || (FilterType = {}));
export var Filter;
(function (Filter) {
    Filter.makeFilter = (field, condition) => {
        switch (field.varType) {
            case VariableType.CONTINUOUS:
                if (condition.type === ConditionType.RANGE) {
                    return Filter.makeContinuousFilter(field, condition);
                }
                break;
            case VariableType.DISCRETE:
                if (condition.type === ConditionType.SELECTION) {
                    return Filter.makeDiscreteFilter(field, condition);
                }
                break;
        }
    };
    Filter.makeContinuousFilter = (field, condition) => {
        if (field.varType === VariableType.CONTINUOUS) {
            const varType = VariableType.CONTINUOUS;
            return {
                field,
                varType,
                range: {
                    type: ConditionType.RANGE,
                    min: condition.min || null,
                    max: condition.max || null,
                    includeMin: condition.includeMin === true ? true : false,
                    includeMax: condition.includeMax === true ? true : false,
                    includeNulls: condition.includeNulls === true ? true : false,
                },
            };
        }
    };
    Filter.makeDiscreteFilter = (field, condition) => {
        if (field.varType === VariableType.DISCRETE) {
            const varType = VariableType.DISCRETE;
            return {
                field,
                varType,
                selection: {
                    type: ConditionType.SELECTION,
                    mode: condition.mode || SelectionMode.INCLUDE,
                    selected: condition.selected || new Set(),
                },
            };
        }
    };
})(Filter || (Filter = {}));
